import React from "react"
import scrollToElement from "scroll-to-element"
import { Tooltip, Flex } from "@chakra-ui/react"
import { Icon } from "../../common"

export default function BackToTop() {
  const handleClick = () => {
    scrollToElement("body", {
      ease: "inOutCirc",
      duration: 1000,
      offset: 0,
    })
  }

  return (
    <Tooltip hasArrow placement="right" label="Back to top">
      <Flex
        as="a"
        onClick={handleClick}
        justifyContent="center"
        position="absolute"
        alignItems="center"
        borderRadius="50%"
        cursor="pointer"
        bg="base.d200"
        top="-25px"
        zIndex={1}
        ml="-25px"
        left="50%"
        h="50px"
        w="50px"
      >
        <Icon name="chevronUp" />
      </Flex>
    </Tooltip>
  )
}
